import { computed as u } from "vue";
const c = (e, n) => ({ iconProps: u(() => {
  if (e.value)
    return typeof e.value == "string" ? {
      ...n,
      url: e.value
    } : typeof e.value == "object" && "render" in e.value ? {
      ...n,
      component: e.value
    } : {
      ...n,
      ...e.value
    };
}) });
export {
  c as u
};
